var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTalkToExpertIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 46,
    viewBox: "0 0 39 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6175 25.1138C21.6175 28.7851 18.6739 31.7289 15 31.7289C11.3274 31.7289 8.38252 28.7851 8.38252 25.1138C8.38252 21.4425 11.3274 18.5 15 18.5C18.6739 18.5 21.6175 21.4425 21.6175 25.1138ZM15 43.5C9.57797 43.5 5 42.6187 5 39.2187C5 35.8174 9.60673 34.9674 15 34.9674C20.4233 34.9674 25 35.8487 25 39.2487C25 42.65 20.3933 43.5 15 43.5Z",
    fill: "#2653F1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 8H32M22 12H26M27 20L23 16H20C18.8954 16 18 15.1046 18 14V6C18 4.89543 18.8954 4 20 4H34C35.1046 4 36 4.89543 36 6V14C36 15.1046 35.1046 16 34 16H31L27 20Z",
    stroke: "#2653F1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTalkToExpertIcon);
export default __webpack_public_path__ + "static/media/talkToExpertIcon.81f62e324a94c7e1870c9a471a8e2e25.svg";
export { ForwardRef as ReactComponent };